import React, { useState } from "react";
import emailjs from "emailjs-com";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      // Replace these with your EmailJS configuration
      const serviceId = "service_xjg1wr8";
      const templateId = "template_inuslyq";
      const userId = "Xa-DsdwJmNMJR75BH";
  
      await emailjs.send(
        serviceId,
        templateId,
        {
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
        },
        userId
      );
  
      // Alert message on success
      alert("I received your message. Thank you!");
  
      setIsSubmitted(true);
      setFormData({
        name: "",
        email: "",
        subject: "",
        message: "",
      });
      setTimeout(() => setIsSubmitted(false), 3000); // Reset message status after 3 seconds
    } catch (error) {
      setErrorMessage("Failed to send message. Please try again later.");
      console.error("EmailJS Error:", error);
    }
  };
  

  return (
    <div id="homecontact" className="bd-contact__area section-space p-relative fix">
      <div className="contact__shape">
        <img className="contact__shape-one" src="assets/imgs/shape/contact-shape-01.png" alt="image not found" />
        <img className="contact__shape-two" src="assets/imgs/shape/contact-shape-02.png" alt="image not found" />
      </div>
      <div className="container">
        <div className="row g-5 align-items-center">
          <div className="col-xl-6 col-lg-6 col-md-6 order-md-0 order-1 wow fadeInLeft" data-wow-delay=".3s">
            <div className="section__title-wrapper section__title-space">
              <h4 className="section__title">Feel Free Contact Me</h4>
            </div>
            <form onSubmit={handleSubmit} className="floating__form-content">
              <div className="row g-4">
                <div className="col-12">
                  <div className="floating__form-input">
                    <input
                      type="text"
                      className="inputText"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                    <span className="floating-label">Name*</span>
                  </div>
                </div>
                <div className="col-12">
                  <div className="floating__form-input">
                    <input
                      type="email"
                      className="inputText"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                    />
                    <span className="floating-label">Email*</span>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="floating__form-input">
                    <input
                      type="text"
                      className="inputText"
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                    />
                    <span className="floating-label">Subject</span>
                  </div>
                </div>
                <div className="col-12 text-center">
                  <div className="from__input-box">
                    <div className="floating__form-input">
                      <textarea
                        className="textareaText"
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        required
                      />
                      <span className="floating-label-two">Message*</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="contact__btn">
                <button type="submit" className="bd-btn w-100" disabled={isSubmitted}>
                  {isSubmitted ? "Message Sent" : "Submit Now"}
                </button>
              </div>
              {errorMessage && <p className="error-message">{errorMessage}</p>}
            </form>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-6 order-md-1 order-0 wow fadeInRight" data-wow-delay=".3s">
            <div className="contact__info-wrapper">
              <div className="contact__info-item">
                <ul>
                  <li>
                    <div className="contact__info">
                      <div className="contact__info-icon">
                        <span>
                          <i className="icon-location"></i>
                        </span>
                      </div>
                      <div className="contact__info-content">
                        <h6>SS Mansion Choolaimedu, Chennai</h6>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="contact__info">
                      <div className="contact__info-icon">
                        <span>
                          <i className="icon-phone"></i>
                        </span>
                      </div>
                      <div className="contact__info-content">
                        <h6>
                          <a href="tel:+918300923800">+91 8300923800</a>
                        </h6>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="contact__info">
                      <div className="contact__info-icon">
                        <span>
                          <i className="icon-envelope"></i>
                        </span>
                      </div>
                      <div className="contact__info-content">
                        <h6>
                          <a href="mailto:saravanaperumal768@gmail.com">saravanaperumal768@gmail.com</a>
                        </h6>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
